module.exports = __webpack_public_path__ + "img/01.b5dfea3d.png";